import { ComputedRef, computed } from 'vue'

export default function useTwelveHourTimeFormat(locale: string): ComputedRef<boolean> {
  return computed<boolean>(
    () => Intl.DateTimeFormat(locale, { hour: 'numeric' }).resolvedOptions().hour12 ?? false,
  )
}
